/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Dispatch, SetStateAction, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  SelectChangeEvent,
  TextField,
} from "@mui/material";

import { useNavigate } from "react-router-dom";

import AddCharges from "../../Modals/addChargesModal";
import RefundModal from "../../Modals/refundModal";
import { CancelledBooking } from "../../types/General";
import { formatDubaiDateTime } from "../../utils/dateTime";
import { BOOKING_STATUS, CANCEL_SORTING, OFFER_TYPE } from "../../utils/enums";

import {
  useAssignEmployeeMutation,
  useCancellationRefundMutation,
  useLazyRefundMembersQuery,
} from "../../service/booking";
import { showError, showToast } from "../../constants/toasts";
import useAuth from "../../hooks/useAuth";
import { isNumber } from "../../utils/validations";
import SwapVertIcon from "@mui/icons-material/SwapVert";

type OfferTableProps = {
  actionType?: "active" | "scheduled" | "expired" | "quick";
  category?: string;
  bookingData?: CancelledBooking[];
  getCancelledBookingsApi: () => void;
  loading: boolean;
  setLoading: Dispatch<SetStateAction<boolean>>;
  mainTab: number;
  categoryId: string | null;
  subTab: number;
  employeeData: EmployeeType[];
  setEmployeeData: Dispatch<SetStateAction<EmployeeType[]>>;
  sortOrder: string;
  setSortOrder: Dispatch<SetStateAction<string>>;
};

interface EmployeeType {
  email: string;
  id: string;
  name: string;
}

enum INTERNAL {
  IN_PROGRESS = "InProgress",
  CONFIRMED = "Confirmed",
  NEW = "New",
  CANCELLED = "Cancelled",
  COMPLETED = "Completed",
  PENDING_CANCELLATION = "PendingCancellation",
}

const CancelTable = ({
  bookingData,
  getCancelledBookingsApi,
  loading,
  setLoading,
  mainTab,
  categoryId,
  subTab,
  employeeData,
  setEmployeeData,
  sortOrder,
  setSortOrder,
}: OfferTableProps) => {
  const navigate = useNavigate();
  const userData = useAuth();

  const [assignEmployee] = useAssignEmployeeMutation();
  const [refundMembers] = useLazyRefundMembersQuery();
  const [cancellationRefund] = useCancellationRefundMutation();

  const [expandedRowId, setExpandedRowId] = useState<string | null>(null);

  const [assignToMe, setAssignToMe] = useState(true);
  const [notesText, setNotesText] = useState("");
  const [Employee, setEmployee] = useState("");
  const [Status, setStatus] = useState("");
  const [open, setOpen] = useState(false);
  const [paidOption, setPaidOption] = useState("");
  const [chargeAmount, setChargeAmount] = useState("");
  const [membersData, setMembersData] = useState([]);
  const [selectedArray, setSelectedArray] = useState<any[]>([]);
  const [cancellationId, setCancellationId] = useState("");

  const toggleExpand = (
    id: any,
    employeeId?: string,
    status?: string,
    amount?: string,
    offerType?: string
  ) => {
    const internalStatus =
      status === INTERNAL.CANCELLED
        ? "Cancelled"
        : status === INTERNAL.PENDING_CANCELLATION
          ? "PendingCancellation"
          : "";

    const employeeAssigned = employeeId;
    setCancellationId(id);

    setAcceptedRows({});
    setNotesText("");
    setPaidOption("");
    setAssignToMe(employeeId === userData?.id ? true : false);
    setEmployee(employeeAssigned || "");
    setStatus(internalStatus || "");
    setExpandedRowId((prevId) => (prevId === id ? null : id));
    setChargeAmount(amount || "0");
  };

  const handleCloseModal = () => {
    setOpen(false);
  };
  const [open1, setOpen1] = useState(false);
  const handleCloseModal1 = () => {
    setOpen1(false);
  };
  const [acceptedRows, setAcceptedRows] = useState<Record<any, boolean>>({});

  const getRefundMembersApi = async (id: string) => {
    try {
      const response = await refundMembers({ bookingId: id }).unwrap();
      if (response.status === 200) {
        setMembersData(response?.data || []);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  const directCancelApi = async (bookingId: string) => {
    if (!assignToMe && !Employee) {
      showError("Please select employee");
      return;
    }

    try {
      setLoading(true);
      const body = {
        type: "Cancellation",
        amount: 0,
        cancelAction: "no",
        bookingId,
        refundMembers: [],
      };

      await assignEmployeeApi(
        bookingId,
        Employee,
        Status,
        notesText,
        "cancelled",
        true,
        true
      );
      const response = await cancellationRefund(body).unwrap();

      setLoading(false);
      if (response.status === 200) {
        showToast(response?.message || "");
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const cancellationRefundApi = async (bookingId: string, charge: boolean) => {
    if (charge && !chargeAmount) {
      showError("Please enter amount");
      return;
    }

    if (!assignToMe && !Employee) {
      showError("Please select employee");
      return;
    }

    try {
      setLoading(true);
      const body = {
        type: charge ? "Cancellation" : "Refund",
        amount: paidOption === "no" ? 0 : Number(chargeAmount) || 0,
        cancelAction: paidOption || "no",
        bookingId,
        refundMembers: selectedArray || [],
      };

      await assignEmployeeApi(
        bookingId,
        Employee,
        Status,
        notesText,
        charge ? "cancelled" : "refund",
        true,
        true
      );
      const response = await cancellationRefund(body).unwrap();

      setLoading(false);
      if (response.status === 200) {
        showToast(response?.message || "");
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const assignEmployeeApi = async (
    bookingId: string,
    employeeId: string,
    status: string,
    notes: string,
    type?: string,
    isAction?: boolean,
    isMessage?: boolean
  ) => {
    if (!assignToMe && !Employee) {
      showError("Please select employee");
      return;
    }
    // if (!Status) {
    //   showError("Please select status");
    //   return;
    // }

    if (!isAction && status === BOOKING_STATUS.CANCELLED) {
      showError("Please select cancellation action first");
      return;
    }

    try {
      const body = {
        bookingId: bookingId,
        type: type === "refund" ? "refund" : "cancelled",
        employeeId: assignToMe ? userData?.id : employeeId,
        ...(Status
          ? {
              bookingStatus:
                type === "refund" || type === "cancelled"
                  ? "Cancelled"
                  : status,
            }
          : {}),
        notes: notes,
      };

      const response = await assignEmployee(body).unwrap();
      if (response.status === 200) {
        if (!isMessage) {
          showToast(response?.message || "");
        }

        setNotesText("");
        setAssignToMe(false);
        setEmployee("");
        setStatus("");

        getCancelledBookingsApi();

        toggleExpand(bookingId);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  return (
    <>
      <div className="table_container">
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th>Booking ID</th>
              <th>
                <div
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  Client Details
                  <SwapVertIcon
                    onClick={() =>
                      setSortOrder(
                        sortOrder === CANCEL_SORTING.ClientDetail_asc
                          ? "ClientDetail_desc"
                          : "ClientDetail_asc"
                      )
                    }
                  />
                </div>
              </th>
              <th>
                <div
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  Offer Name
                  <SwapVertIcon
                    onClick={() =>
                      setSortOrder(
                        sortOrder === CANCEL_SORTING.OfferName_asc
                          ? "OfferName_desc"
                          : "OfferName_asc"
                      )
                    }
                  />
                </div>
              </th>
              <th>
                <div
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  Booking Time
                  <SwapVertIcon
                    onClick={() =>
                      setSortOrder(
                        sortOrder === CANCEL_SORTING.BookingTime_asc
                          ? "BookingTime_desc"
                          : "BookingTime_asc"
                      )
                    }
                  />
                </div>
              </th>
              <th>
                <div
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  Cancellation Date
                  <SwapVertIcon
                    onClick={() =>
                      setSortOrder(
                        sortOrder === CANCEL_SORTING.CancelledDate_asc
                          ? "CancelledDate_desc"
                          : "CancelledDate_asc"
                      )
                    }
                  />
                </div>
              </th>
              <th>Guests</th>
              <th>
                <div
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  Category
                  <SwapVertIcon
                    onClick={() =>
                      setSortOrder(
                        sortOrder === CANCEL_SORTING.Category_asc
                          ? "Category_desc"
                          : "Category_asc"
                      )
                    }
                  />
                </div>
              </th>
              <th>Employee Name</th>

              <th>
                <div
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  Internal Status
                  <SwapVertIcon
                    onClick={() =>
                      setSortOrder(
                        sortOrder === CANCEL_SORTING.Status_asc
                          ? "Status_desc"
                          : "Status_asc"
                      )
                    }
                  />
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            {bookingData?.length ? (
              bookingData?.map((row) => (
                <React.Fragment key={row?.id}>
                  <tr>
                    <td
                      className="cursor_p"
                      onClick={() =>
                        navigate(
                          `/manage-booking-resvp/booking-detail/${row?.guidBookingId}`,
                          {
                            state: {
                              status: subTab,
                              categoryTab: mainTab,
                              categoryId: categoryId,
                              cancel: true,
                              isRefund:
                                (row?.offerType === OFFER_TYPE.EVENTS &&
                                  row?.eventType === "Paid") ||
                                row?.offerType === OFFER_TYPE.CONTACT_DEALERS
                                  ? true
                                  : false,
                              internalStatus: row?.status,
                            },
                          }
                        )
                      }
                    >
                      {row?.bookingId}
                    </td>

                    <td
                      className="max_c2 cursor_p"
                      onClick={() => {
                        if (row?.userName) {
                          navigate(
                            `/manage-customers/detail/${row?.userName?.userId}`,
                            {
                              state: {
                                status: "APPROVED",
                                memberType: row?.userName?.membershipType,
                                subTab: subTab,
                                categoryTab: mainTab,
                                categoryId: categoryId,
                                comingFrom: "cancel",
                              },
                            }
                          );
                        } else {
                        }
                      }}
                    >
                      {row?.userName?.name || "-"}
                      <br />
                      <small>
                        {`${row?.userName?.phoneNumber?.countryDialCode ? `+${row?.userName?.phoneNumber?.countryDialCode}` : ""} ${row?.userName?.phoneNumber?.phone || "-"}`}
                      </small>
                    </td>

                    <td
                      className="cursor_p max_c2"
                      onClick={() =>
                        navigate(
                          `/manage-booking-resvp/booking-detail/${row?.guidBookingId}`,
                          {
                            state: {
                              status: subTab,
                              categoryTab: mainTab,
                              categoryId: categoryId,
                              cancel: true,
                              isRefund:
                                (row?.offerType === OFFER_TYPE.EVENTS &&
                                  row?.eventType === "Paid") ||
                                row?.offerType === OFFER_TYPE.CONTACT_DEALERS
                                  ? true
                                  : false,
                              internalStatus: row?.status,
                            },
                          }
                        )
                      }
                    >
                      <p> {row?.title || "-"}</p>
                    </td>
                    <td className="max_c2">
                      <p
                        className="text_btn cursor_p"
                        onClick={() => {
                          if (subTab === 0) {
                            toggleExpand(
                              row?.guidBookingId,
                              row?.employee?.id,
                              row?.status,
                              row?.offerCancellationAmount,
                              row?.offerType
                            );
                          }
                        }}
                      >
                        {row?.bookingDate
                          ? formatDubaiDateTime(row?.bookingDate)
                          : "-"}
                      </p>{" "}
                    </td>
                    <td className="max_c2">
                      <p className="cursor_p">
                        {row?.cancellationRequestDateTime
                          ? formatDubaiDateTime(
                              row?.cancellationRequestDateTime
                            )
                          : "-"}
                      </p>{" "}
                    </td>
                    <td className="max_c2">{row?.totalNumberofGuest || "0"}</td>
                    <td className="max_c2">{row?.categoryName || "-"}</td>
                    <td className="max_c2">{row?.employee?.name || "-"}</td>

                    <td className="max_c2">
                      {row?.status === BOOKING_STATUS.PENDING_CANCELLATION
                        ? "Pending Cancellation"
                        : row?.status === BOOKING_STATUS.PENDING_PAYMENT
                          ? "Pending Payment"
                          : row?.status}
                    </td>
                  </tr>

                  {expandedRowId === row?.guidBookingId && (
                    <tr>
                      <td colSpan={8}>
                        <div className="expanded-content">
                          <div className="form_flex">
                            <div className="w_100">
                              <div className="control_group employee_list  mb_0">
                                <Select
                                  value={Employee}
                                  onChange={(e: SelectChangeEvent) =>
                                    setEmployee(e.target.value)
                                  }
                                  displayEmpty
                                >
                                  <MenuItem value="" disabled>
                                    Employee Listing
                                  </MenuItem>
                                  {employeeData?.map((item) => {
                                    return (
                                      <MenuItem key={item?.id} value={item?.id}>
                                        {item?.name || "-"}
                                      </MenuItem>
                                    );
                                  })}
                                </Select>
                              </div>

                              <Select
                                value={Status}
                                onChange={(e: SelectChangeEvent) =>
                                  setStatus(e.target.value)
                                }
                                className="booking_status"
                                displayEmpty
                              >
                                <MenuItem value={""} disabled>
                                  Status
                                </MenuItem>
                                <MenuItem value={"PendingCancellation"}>
                                  Pending Cancellation
                                </MenuItem>
                                <MenuItem value={"Cancelled"}>
                                  Cancelled
                                </MenuItem>
                              </Select>
                              <div className="control_group add_note">
                                <TextField
                                  placeholder="Add Notes"
                                  hiddenLabel
                                  fullWidth
                                  value={notesText}
                                  inputProps={{ maxLength: 150 }}
                                  onChange={(e) => {
                                    if (
                                      e.target.value === " " ||
                                      e.target.value === "."
                                    ) {
                                    } else {
                                      setNotesText(e.target.value);
                                    }
                                  }}
                                />
                              </div>
                              <Button
                                onClick={() =>
                                  assignEmployeeApi(
                                    row?.guidBookingId,
                                    Employee,
                                    Status,
                                    notesText
                                  )
                                }
                                className="btn btn_primary"
                              >
                                Save
                              </Button>
                              <Button
                                className="btn btn_primary"
                                onClick={() => {
                                  if (row?.totalNumberofGuest === 0) {
                                    cancellationRefundApi(
                                      row?.guidBookingId,
                                      false
                                    );
                                  } else if (
                                    (row?.offerType === OFFER_TYPE.RESTAURANT ||
                                      row?.offerType === OFFER_TYPE.OTHERS) &&
                                    !row?.isCancellation
                                  ) {
                                    directCancelApi(row?.guidBookingId);
                                  } else {
                                    setAcceptedRows((prev) => ({
                                      ...prev,
                                      [row?.guidBookingId]: true,
                                    }));
                                  }
                                }}
                              >
                                Accept
                              </Button>
                            </div>
                            <div className="w_100">
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={assignToMe}
                                    onChange={(e) => {
                                      setAssignToMe(e.target.checked);
                                      if (e.target.checked) {
                                        setEmployee(userData?.id || "");
                                      } else {
                                        setEmployee("");
                                      }
                                    }}
                                  />
                                }
                                label="Assign to me"
                              />

                              {acceptedRows[row?.guidBookingId] &&
                              (row?.offerType === OFFER_TYPE.RESTAURANT ||
                                row?.offerType === OFFER_TYPE.OTHERS) ? (
                                <>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "20px",
                                    }}
                                  >
                                    <div className="control_group charge_field">
                                      <h2>Do you want to charge?</h2>
                                    </div>
                                    <div className="control_group ">
                                      <FormControl className="paid_radio">
                                        <RadioGroup
                                          aria-labelledby="demo-radio-buttons-group-label"
                                          defaultValue="female"
                                          name="radio-buttons-group"
                                          value={paidOption}
                                          onChange={(e) =>
                                            setPaidOption(e.target.value)
                                          }
                                        >
                                          <FormControlLabel
                                            value="yes"
                                            control={<Radio />}
                                            label="Yes"
                                          />
                                          <FormControlLabel
                                            value="no"
                                            control={<Radio />}
                                            label="No"
                                          />
                                        </RadioGroup>
                                      </FormControl>
                                    </div>
                                    {paidOption === "yes" && (
                                      <div className="control_group default_charge_field">
                                        <TextField
                                          placeholder="Charge Amount"
                                          hiddenLabel
                                          fullWidth
                                          value={chargeAmount}
                                          inputProps={{ maxLength: 5 }}
                                          onChange={(e) => {
                                            const { value } = e.target;
                                            if (isNumber(value)) {
                                              setChargeAmount(value);
                                            }
                                          }}
                                        />
                                      </div>
                                    )}{" "}
                                    {paidOption ? (
                                      <Button
                                        className="btn btn_primary"
                                        onClick={() => {
                                          cancellationRefundApi(
                                            row?.guidBookingId,
                                            true
                                          );
                                        }}
                                      >
                                        Save
                                      </Button>
                                    ) : null}
                                  </div>
                                </>
                              ) : null}

                              {acceptedRows[row?.guidBookingId] &&
                              ((row?.offerType === OFFER_TYPE.EVENTS &&
                                row?.eventType === "Paid") ||
                                row?.offerType ===
                                  OFFER_TYPE.CONTACT_DEALERS) ? (
                                <>
                                  <div className="control_group charge_field">
                                    <h2>Do you want to refund?</h2>
                                  </div>
                                  <div className="control_group">
                                    {/* {mode === "refunded" ? (
                                      <>
                                        <Button
                                          className="btn btn_primary"
                                          // onClick={() =>
                                          //   navigate(
                                          //     `/manage-booking-resvp/booking-detail?category=${row.Category}`
                                          //   )
                                          // }
                                        >
                                          Refunded
                                        </Button>
                                      </>
                                    ) : ( */}
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "10px",
                                      }}
                                    >
                                      <FormControl className="paid_radio">
                                        <RadioGroup
                                          aria-labelledby="demo-radio-buttons-group-label"
                                          name="radio-buttons-group"
                                          value={paidOption}
                                          onChange={(e) =>
                                            setPaidOption(e.target.value)
                                          }
                                        >
                                          <FormControlLabel
                                            value="yes"
                                            control={<Radio />}
                                            label="Yes"
                                            onClick={() => {
                                              getRefundMembersApi(
                                                row?.guidBookingId
                                              );
                                              setOpen1(true);
                                            }}
                                          />
                                          <FormControlLabel
                                            value="no"
                                            control={<Radio />}
                                            label="No"
                                          />
                                        </RadioGroup>
                                      </FormControl>
                                      {paidOption && paidOption === "no" ? (
                                        <Button
                                          className="btn btn_primary"
                                          onClick={() => {
                                            cancellationRefundApi(
                                              row?.guidBookingId,
                                              false
                                            );
                                          }}
                                        >
                                          Save
                                        </Button>
                                      ) : null}
                                    </div>
                                    {/* )} */}
                                  </div>
                                </>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))
            ) : (
              <tr>
                <td
                  colSpan={8}
                  style={{ textAlign: "center", padding: "20px" }}
                >
                  No Data Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <AddCharges open={open} onClose={handleCloseModal} setOpen={setOpen} />
      <RefundModal
        open={open1}
        onClose={handleCloseModal1}
        setOpen={setOpen1}
        membersData={membersData}
        setMembersData={setMembersData}
        setSelectedArray={setSelectedArray}
        selectedArray={selectedArray}
        cancellationRefundApi={cancellationRefundApi}
        cancellationId={cancellationId}
      />
    </>
  );
};

export default CancelTable;
